var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCountries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_20X20_photo_Back",
    "data-name": "20X20 photo Back",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4536",
    "data-name": "Rectangle 4536",
    width: 20,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_90",
    "data-name": "Mask Group 90",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coronavirus-2",
    transform: "translate(-0.893 -0.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15999",
    "data-name": "Path 15999",
    d: "M7.829,2.952a.641.641,0,1,0-.64-.641.641.641,0,0,0,.64.641Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16000",
    "data-name": "Path 16000",
    d: "M7.882,4.744,9,3.251a1.48,1.48,0,0,0,.3-.983,1.421,1.421,0,0,0-2.84,0,1.518,1.518,0,0,0,.305.986Zm-.054-3.5A1.066,1.066,0,1,1,6.763,2.31,1.066,1.066,0,0,1,7.829,1.244Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16001",
    "data-name": "Path 16001",
    d: "M15.446,6.49a.749.749,0,0,0,.473.251l.124.015a1.1,1.1,0,0,1,.913.769,1.073,1.073,0,0,1-.315,1.112L15.41,9.726a.709.709,0,0,0-.239.531v.289a.554.554,0,0,0,.254.467,1.029,1.029,0,0,1,.468.766l.029.289a.476.476,0,0,0,.475.43h.721a1.069,1.069,0,0,0,.979-.64l.043-.1a1.033,1.033,0,0,1,.9-.621l.169-.008.057,0,.411-.041a13.929,13.929,0,0,0-.458-2.372l-.241.323a.213.213,0,0,1-.341,0L17.607,7.652a1.605,1.605,0,0,1-.32-1.046,1.582,1.582,0,0,1,.224-.716,9.582,9.582,0,0,0-1.426-1.156l-.7,1.2a.487.487,0,0,0,.057.561Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16002",
    "data-name": "Path 16002",
    d: "M18.812,8.553,19.677,7.4a1.148,1.148,0,0,0,.236-.762,1.1,1.1,0,0,0-2.2,0,1.178,1.178,0,0,0,.237.765Zm-.043-2.785a.9.9,0,1,1-.9.9.9.9,0,0,1,.9-.9Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16003",
    "data-name": "Path 16003",
    d: "M19.313,11.55l-.08.006-.169.008a.61.61,0,0,0-.534.367l-.043.1a1.5,1.5,0,0,1-1.369.895H16.4a.9.9,0,0,1-.9-.813l-.029-.289a.606.606,0,0,0-.275-.451.978.978,0,0,1-.449-.825v-.289a1.135,1.135,0,0,1,.383-.85L16.36,8.318a.646.646,0,0,0,.19-.67.669.669,0,0,0-.558-.47l-.124-.015a1.174,1.174,0,0,1-.741-.393.914.914,0,0,1-.106-1.053L15.727,4.5a10.751,10.751,0,0,0-1.176-.624A9.219,9.219,0,0,0,10.8,3.015c-.114,0-.239,0-.372.011l.945,1.363a1.488,1.488,0,0,1-.044,1.761l-.3.393a1.165,1.165,0,0,1-1.066.443l-.344-.044a.777.777,0,0,0-.769.378,1.169,1.169,0,0,1-1.157.568l-.793-.1a.821.821,0,0,0-.787.356.677.677,0,0,0-.011.741l.524.828a.6.6,0,0,0,.785.207l.54-.289a1.755,1.755,0,0,1,1.3-.074,1.843,1.843,0,0,1,3.659.236,1.9,1.9,0,0,1-.388,1.266l-.333.445.2.268q.043.06.089.114l.655.772A.8.8,0,0,1,13,13.813l-.993.764a1.132,1.132,0,0,0-.394.567l-.331,1.075a1.134,1.134,0,0,1-.213.393L10.749,17a1.42,1.42,0,0,0-.321.764.976.976,0,0,1-.593.8.721.721,0,0,1-.99-.547l-.3-1.822a.946.946,0,0,0-.18-.416L7.249,14.319a1.754,1.754,0,0,1-.3-.6L6.586,12.4a.927.927,0,0,0-.646-.644l-.08-.022a1.5,1.5,0,0,1-.629-.353l-.684-.645a2.014,2.014,0,0,1-.361-.456,1.055,1.055,0,0,0-1.1-.508l-1,.324a8.924,8.924,0,1,0,17.649,1.861c0-.139-.005-.288-.015-.446Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16004",
    "data-name": "Path 16004",
    d: "M18.769,7.14a.473.473,0,1,0-.473-.473A.473.473,0,0,0,18.769,7.14Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16005",
    "data-name": "Path 16005",
    d: "M3.687,6.416a.641.641,0,1,0-.64-.641A.641.641,0,0,0,3.687,6.416Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16006",
    "data-name": "Path 16006",
    d: "M2.986,9.354a1.481,1.481,0,0,1,1.567.71,1.588,1.588,0,0,0,.285.36l.684.645a1.067,1.067,0,0,0,.449.252l.08.022A1.354,1.354,0,0,1,7,12.283l.367,1.325a1.33,1.33,0,0,0,.225.453L8.7,15.52a1.372,1.372,0,0,1,.261.6l.3,1.822a.3.3,0,0,0,.406.225A.551.551,0,0,0,10,17.719a1.844,1.844,0,0,1,.417-.992l.322-.388a.711.711,0,0,0,.133-.246l.331-1.075a1.555,1.555,0,0,1,.541-.779l.993-.763a.376.376,0,0,0,.057-.541l-.655-.772c-.038-.045-.075-.093-.11-.141l-.117-.161-.687.919a.213.213,0,0,1-.341,0L9.6,11.059A1.986,1.986,0,0,1,9.214,10a1.341,1.341,0,0,0-1.064.006l-.54.289a1.012,1.012,0,0,1-.479.12,1.025,1.025,0,0,1-.866-.475l-.524-.828a1.1,1.1,0,0,1,.019-1.207,1.244,1.244,0,0,1,1.193-.54l.793.1a.744.744,0,0,0,.736-.362,1.2,1.2,0,0,1,1.19-.584l.344.044a.737.737,0,0,0,.675-.281l.3-.393a1.064,1.064,0,0,0,.032-1.259L9.939,3.064c-.121.012-.244.026-.367.042a2,2,0,0,1-.233.4L8.053,5.227a.213.213,0,0,1-.341,0L6.765,3.96a11.961,11.961,0,0,0-1.424.922A1.891,1.891,0,0,1,5.2,6.97L3.911,8.691a.213.213,0,0,1-.341,0l-.682-.913A10.026,10.026,0,0,0,2.2,9.608l.76-.247.025-.006Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16007",
    "data-name": "Path 16007",
    d: "M12.176,10.8a1.48,1.48,0,0,0,.3-.983,1.421,1.421,0,0,0-2.84,0,1.518,1.518,0,0,0,.305.986L11.06,12.3ZM9.94,9.864a1.066,1.066,0,1,1,1.066,1.066A1.066,1.066,0,0,1,9.94,9.864Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_320",
    "data-name": "Ellipse 320",
    cx: 0.64,
    cy: 0.641,
    rx: 0.64,
    ry: 0.641,
    transform: "translate(10.366 9.223)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16008",
    "data-name": "Path 16008",
    d: "M3.74,8.209,4.857,6.715a1.48,1.48,0,0,0,.3-.983A1.451,1.451,0,0,0,3.74,4.358,1.451,1.451,0,0,0,2.32,5.731a1.518,1.518,0,0,0,.305.986Zm-.054-3.5A1.066,1.066,0,1,1,2.621,5.775,1.066,1.066,0,0,1,3.687,4.709Z",
    fill: "#404040"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountries);
export default __webpack_public_path__ + "static/media/Countries.8b2aa93266644853dec1ddcb23bad380.svg";
export { ForwardRef as ReactComponent };